<app-modal-shell
  [title]="title"
  [primaryLabel]="'Add'"
  [primaryDisabled]="!(versionForm.valid && isFormChanged())"
  [errorMessage]="isErrorVisible ? errorMessage : null"
  (closed)="closePopup()"
  (submitted)="handleSubmit()"
>
  <form [formGroup]="versionForm" class="form-body">
    <app-searchable-object-multi-select
      [inputStyle]="'popup-form-field'"
      [label]="selectBaseApplicationLabel"
      formControlName="baseApp"
      [placeholder]="selectBaseApplicationPlaceholder"
      [required]="true"
      [options]="appSelectOptions"
      [display]="appSelectDisplayFn"
      [compare]="appSelectCompareFn"
      [multiple]="false"
    >
    </app-searchable-object-multi-select>

    <!-- Application Version -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="appVersionLabel"
      [formCntlName]="version"
      [placeholder]="appVersionPlaceholder"
      [required]="true"
      [inputType]="'text'"
    >
    </app-input>
    @if (version.hasError('required') && version.touched) {
      <div class="mat-error-msg">
        <span i18n>Application Version is required.</span>
      </div>
    }
    @if (version.hasError('pattern') && version.touched) {
      <div class="mat-error-msg">
        <span i18n>Version must be in format X.Y.Z or W.X.Y.Z.</span>
      </div>
    }

    <!-- Container Name -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="containerNameLabel"
      [formCntlName]="containerName"
      [placeholder]="containerNamePlaceholder"
      [required]="true"
      [inputType]="'text'"
    >
    </app-input>
    @if (containerName.hasError('required') && containerName.touched) {
      <div class="mat-error-msg">
        <span i18n>Container Name is required.</span>
      </div>
    }
    @if (containerName.hasError('whitespace') && containerName.touched) {
      <div class="mat-error-msg">
        <span>Input cannot be just spaces.</span>
      </div>
    }

    <!-- Inputs -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="inputTypeLabel"
      [subLabel]="inputTypeSubLabel"
      [formCntlName]="inputType"
      [required]="false"
      [inputType]="'text'"
    >
    </app-input>
    @if (inputType.hasError('whitespace') && inputType.touched) {
      <div class="mat-error-msg">
        <span>Input cannot be just spaces.</span>
      </div>
    }
    <app-searchable-object-multi-select
      [inputStyle]="'popup-form-field'"
      [label]="dependsOnAppsLabel"
      formControlName="dependsOnAppVersions"
      [placeholder]="dependsOnAppsPlaceholder"
      [options]="dependsOnAppsSelectOptions"
      [display]="dependsOnAppsSelectDisplayFn"
      [compare]="dependsOnAppsSelectCompareFn"
      [multiple]="true"
    >
    </app-searchable-object-multi-select>

    <!-- Multi-run -->
    <div class="multi-run-field">
      <app-checkbox
        [label]="multiRunLabel"
        [isChecked]="multiRun.value ?? false"
        (checkedChange)="onMultiRunChange($event)"
      ></app-checkbox>
      <span class="sub-label">{{ multiRunSubLabel }}</span>
    </div>
  </form>
</app-modal-shell>
